import { DEVICE } from '../views/Preview';

const getDataFromResponse = async (
  response: Response,
): Promise<{
  ccpa: {
    isActive: boolean;
    region: string;
  };
  selectedSettingsAppVersion?: string;
  tcf2Enabled: boolean;
  variants: { enabled: boolean; experiments: string };
  dsrConfigurationId?: string;
}> => {
  const text = await response.text();
  const data = text === '' ? {} : JSON.parse(text);

  return data.data || data;
};

export const fetchSettingsJson = async (
  id: string,
  version: string,
  language: string,
  useSandbox: boolean,
): Promise<{
  ccpa: {
    isActive: boolean;
    region: string;
  };
  framework?: string;
  selectedSettingsAppVersion?: string;
  tcf2Enabled: boolean;
  variants: { enabled: boolean; experiments: string };
  dsrConfigurationId?: string;
}> => {
  const basePath = useSandbox ? 'https://api.usercentrics-sandbox.eu' : 'https://api.usercentrics.eu';
  const url = `${basePath}/settings/${id}/${version}/${language}.json`;
  const response = await fetch(url);

  return getDataFromResponse(response);
};

export const getVariants = (data: { enabled: boolean; experiments: string }): string[] => {
  if (data.enabled) {
    try {
      return Object.keys(JSON.parse(data.experiments));
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(`Invalid JSON string`);
    }
  }

  return [];
};

export type ParamType = {
  settingsId: string;
  location: string;
  version: string;
};

enum AppId {
  ios = '9bkd1jjcweqk0cxcx2c7hvthtc',
  android = 'b_536zsm5xhhrslpeiyf46d6owni',
}

enum SandboxAppId {
  ios = 'f4q0j1mugzug6yefcktucwxyj0',
  android = 'b_zppl2nm6ancjoel7oc47ystuee',
}

enum MobileModel {
  ios = 'iphone17pro',
  android = 'pixel7',
}

enum OsVersion {
  ios = '26.0',
  android = '15.0',
}

export const getMobileSource = (
  device: DEVICE,
  urlParams: ParamType,
  useSandbox: boolean,
  appType: 'embed' | 'app' = 'embed',
): string => {
  const androidId = useSandbox ? SandboxAppId.android : AppId.android;
  const iosId = useSandbox ? SandboxAppId.ios : AppId.ios;
  const appId = device === DEVICE.IOS ? iosId : androidId;
  const mobileModel = device === DEVICE.IOS ? MobileModel.ios : MobileModel.android;
  const osVersion = device === DEVICE.IOS ? OsVersion.ios : OsVersion.android;

  return `https://appetize.io/${appType}/${appId}?device=${mobileModel}&scale=75&orientation=portrait&osVersion=${osVersion}&deviceColor=black&params=${encodeURI(
    JSON.stringify(urlParams),
  )}${device === DEVICE.ANDROID ? `&launchUrl=${encodeURI('usercentrics://preview')}` : ''}`;
};
